import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ImageCellRendererParams } from '../../ag-grid.model';

type IImageCellRendererParams = ICellRendererParams & ImageCellRendererParams;

@Component({
  selector: 'y42-image-cell-renderer',
  templateUrl: './image-cell-renderer.component.html',
  styleUrls: ['./image-cell-renderer.component.scss'],
})
export class ImageCellRendererComponent implements ICellRendererAngularComp {
  image = '';
  tooltip = '';
  imageWidth = 50;
  imageHeight = 50;

  agInit(params: IImageCellRendererParams): void {
    this.image = params.value || params.getImageSrc?.(params.node);
    this.imageWidth = params.width !== undefined ? params.width : 50;
    this.imageHeight = params.height !== undefined ? params.height : 50;
    this.tooltip = params.getTooltip?.(params.node) || '';
  }

  refresh(): boolean {
    return true;
  }
}
